module.exports = __webpack_public_path__ + "img/banner-2.7e4d1f0d.jpg";